import { ChangeDetectionStrategy, Component, input, signal, viewChild } from '@angular/core';
import { EmblaSliderComponent } from '@teamfoster/embla-slider';
import { Header } from 'src/app/core/models';
import { HeaderComponent } from '../../../core/components/header/header.component';
import Fade from 'embla-carousel-fade';
import { IconComponent } from 'src/app/core/components/icon/icon.component';

@Component({
  selector: 'app-header-slider',
  templateUrl: './header-slider.component.html',
  styleUrls: ['./header-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeaderComponent, EmblaSliderComponent, IconComponent],
})
export class HeaderSliderComponent {
  headers = input<Header[]>([]);
  slider = viewChild<EmblaSliderComponent>('sliderEl');

  activeSlideIndex = signal(0);
  fade = Fade();
}
